import Request from './Request'

const storage_user_key = 'current_user'
const active_client_storage_key = 'retailorbit.active_client'

function clearSession() {
	localStorage.removeItem(storage_user_key)
	localStorage.removeItem('access_token')
	localStorage.removeItem(active_client_storage_key)
}

const AuthService = {
	async logout() {
		try {
			await Request.get('/api/logout');
		} catch (e) {
			console.error('Logout failed:', e);
			throw e;
		} finally {
			clearSession()
		}
	},
	setCurrentUser( user, ignore_access_token=false ) {
		if (!user) {
			clearSession()
			return
		}

		localStorage.setItem(storage_user_key, JSON.stringify(user))
		if( user?.auth && user.auth.access_token && !ignore_access_token ) {
			localStorage.setItem('access_token', user.auth.access_token)
		}
	},
	getAuthenticatedLocalUser() {
		if (!this.getAccessToken()) {
			clearSession()
			return null
		}

		return this.getLocalUser()
	},
	getLocalUser() {
		let user = localStorage.getItem(storage_user_key)
		if (!user || user === 'undefined') {
			localStorage.removeItem(storage_user_key)
			return null
		}

		try {
			return JSON.parse(user)
		} catch (e) {
			console.error('Failed to parse current user from localStorage:', e)
			localStorage.removeItem(storage_user_key)
			return null
		}
	},
	setAccessToken(token) {
		localStorage.setItem('access_token', token)
	},
	getAccessToken() {
		return localStorage.getItem('access_token')
	},
	async spoofUser(user_id) {
		return await Request.post(`/api/users/${user_id}/spoof`)
	},
	async forgotPassword(email) {
		return await Request.post('/api/forgot-password', {email})
	},
	async resetPassword(data) {
		return await Request.post('/api/reset-password', data)
	}
}

export default AuthService